import AbstractAlGuestlistEditorPagesController from '../../abstracts/abstract-page-controller';
import moment from 'moment';

export default class AlGuestlistEditorPageFormComponentController extends AbstractAlGuestlistEditorPagesController {

    constructor($injector, $scope) {
        super($injector, $scope);

        this.registrationTypes = [
            {
                key: 'no_external',
                settings: {
                    enable_open_registration: false,
                    enable_code_registration: false
                }
            },
            {
                key: 'just_open',
                settings: {
                    enable_open_registration: true,
                    enable_code_registration: false
                }
            },
            {
                key: 'just_closed',
                settings: {
                    enable_open_registration: false,
                    enable_code_registration: true
                }
            },
            {
                key: 'open_and_closed',
                settings: {
                    enable_open_registration: true,
                    enable_code_registration: true
                }
            }
        ];

        this.definitionChangeCounts = {};

        this.copyMainGuestFieldModels = {
            guests: {
                state: true,
                field_setting: 'registration_guest_fields',
                enable_setting: 'enable_guests'
            },
            recommendations: {
                state: true,
                field_setting: 'recommendations_fields',
                enable_setting: 'enable_recommendations'
            },
            representative: {
                state: true,
                field_setting: 'representative_fields',
                enable_setting: 'enable_representative'
            }
        };
        this.currentRegistrationType = 'just_open';
        this.statusMappingPresets = [
            {
                key: "no_change"
            },
            {
                key: "allow_cancellation"
            },
            {
                key: "allow_all_changes"
            },
            {
                key: "individual"
            }
        ];
        this.currentStatusMappingPreset = 'individual';

        this.registrationTimeRangeEnabled = false;
        this.dateFields = {
            registration_start: moment(),
            registration_end: moment()
        };

        this.openRegPasswordEnabled = false;

        this.doNotAutoConfirmOpenRegistration = true;
        this.modelPrepared = false;
        this.internalDefinitions = {};
        this.statusFlow = {};
        this.statusFlowUpdateCount = 0;
        this.internalPaxPlannedMax = 0;

        this.reloginStatesUpdateCount = 0;
        this.currentReloginStates = [];

        this.fields = [];
        this.loading = false;
        this.lp = $injector.get('$httpBackend');
        this.rootScope = $injector.get('$rootScope');
        this.env = $injector.get('Env');

        this._initSpecialWatchers();
    }

    updateFieldDefinition(setting, newDefinition, ignoreEnabledFields) {
        if (!this.definitionChangeCounts[setting]) {
            this.definitionChangeCounts[setting] = 0;
        }
        const currentChangeCount = ++this.definitionChangeCounts[setting];

        this.internalDefinitions[setting] = newDefinition;

        _.set(this.model, `settings.${setting}`, null);

        this.injector.get('$timeout')(() => {
            if (currentChangeCount >= this.definitionChangeCounts[setting]) {
                _.set(this.model, `settings.${setting}`, newDefinition);
            }

            if (!ignoreEnabledFields && this.onEnabledFieldsUpdate) {
                const currentEnabledFields = _.cloneDeep(this.enabledFields);
                _.each(newDefinition, (field) => {
                    if (currentEnabledFields.indexOf(field.slug) === -1) {
                        currentEnabledFields.push(field.slug);
                    }
                });

                if (!_.isEqual(currentEnabledFields, this.enabledFields)) {
                    this.onEnabledFieldsUpdate({newFieldList: currentEnabledFields});
                }
            }
        }, 0);
    }

    triggerCustomFieldChange(action, group, definition, number) {
        this.onCustomFieldChange({action, group, definition, number});
    }

    handleSubPersonGroupChange(groupIdentifier) {
        const groupConfig = this.copyMainGuestFieldModels[groupIdentifier];

        if (this.model.settings[groupConfig.enable_setting]) {
            groupConfig.state = true;
        } else {
            this.model.settings[groupConfig.field_setting] = [];
        }
    }

    handleCopyMainGuestFieldsChange(groupIdentifier) {
        const groupConfig = this.copyMainGuestFieldModels[groupIdentifier];

        if (groupConfig.state) {
            this.updateFieldDefinition(groupConfig.field_setting, _.cloneDeep(this.model.settings.registration_fields));
        }
    }

    toggleStatusFlowSelection(toggleState, arrayOfData) {
        const index = arrayOfData.indexOf(toggleState);

        if (index > -1) {
            arrayOfData.splice(index, 1);
        } else {
            arrayOfData.push(toggleState);
        }
    }

    // Internal functions
    _initWatchers() {
        super._initWatchers();

        this.scope.$watch(() => {
            return this.currentRegistrationType;
        }, () => {
            _.each(this.registrationTypes, (typeInfo) => {
                if (typeInfo.key === this.currentRegistrationType) {
                    this.model.settings = {
                        ...this.model.settings,
                        ..._.cloneDeep(typeInfo.settings)
                    }
                }
            });

            if (!this.model.settings.enable_code_registration) {
                this.model.settings.enable_logged_in_registration = false;
            }

            this._triggerModelUpdate();
        });

        this.scope.$watch(() => {
            return this.statusFlow;
        }, (newValue) => {
            const currentUpdateCount = ++this.statusFlowUpdateCount;

            this.model.settings.registration_status_flow = null;
            this.injector.get('$timeout')(() => {
                if (currentUpdateCount >= this.statusFlowUpdateCount) {
                    this.model.settings.registration_status_flow = newValue;
                }
            }, 0);
        }, true);

        this.scope.$watch(() => {
            return this.enabledFields;
        }, (newValue) => {
            if (this.modelPrepared) {
                const definitionFields = ['registration_fields', 'registration_guest_fields', 'recommendation_fields', 'represetative_fields'],
                    checkAndCleanUpDefinition = (oldDefinition) => {
                        let newDefinition = _.cloneDeep(oldDefinition);

                        _.each(oldDefinition, (value, key) => {
                            if (!value || !value.slug || this.enabledFields.indexOf(value.slug) === -1) {
                                delete newDefinition[key];
                            }
                        });

                        return _.filter(_.values(newDefinition));
                    };

                // Check all definitions, if they still match available fields, otherwise delete not enabled fields
                const newDefinitions = {};
                _.each(definitionFields, (field) => {
                    const oldDefinition = _.cloneDeep(this.internalDefinitions[field]),
                        newDefinition = checkAndCleanUpDefinition(oldDefinition);

                    if (!_.isEmpty(oldDefinition) && !_.isEqual(oldDefinition, newDefinition)) {
                        newDefinitions[field] = newDefinition;
                    }
                });

                _.each(newDefinitions, (newDefinition, setting) => {
                    this.updateFieldDefinition(setting, newDefinition, true);
                });
            }
        }, true);

        this.scope.$watch(() => {
            return _.get(this.globalModel, 'settings.add_contacts_to_addressbook');
        }, () => {
            const value = _.get(this.globalModel, 'settings.add_contacts_to_addressbook', null);

            if (!_.isNull(value) && !this.globalModel.settings.add_contacts_to_addressbook) {
                this.model.settings.identify_contact_by_email = false;
                this.model.settings.overwrite_data_of_email_identified_contact = false;
            }

            this._triggerModelUpdate();
        });

        this.scope.$watch(() => {
            return this.dateFields;
        }, () => {
            if (this.modelPrepared) {
                _.set(this.model, 'settings.registration_start', this.dateFields.registration_start ? this.transformDateFieldForModel(this.dateFields.registration_start) : null);
                _.set(this.model, 'settings.registration_end', this.dateFields.registration_end ? this.transformDateFieldForModel(this.dateFields.registration_end) : null);
            }
            this._triggerModelUpdate()
        }, true);

        this.scope.$watch(() => {
            return this.openRegPasswordEnabled;
        }, () => {
            if (this.modelPrepared && this.openRegPasswordEnabled) {
                this.model.settings.open_reg_password = '';
                this._triggerModelUpdate();
            }
        }, true);

        this.scope.$watch(() => {
            return this.registrationTimeRangeEnabled;
        }, () => {
            if (this.modelPrepared) {
                if (this.registrationTimeRangeEnabled) {
                    this.dateFields.registration_end = this.transformDateForDateField(moment());
                    this.dateFields.registration_start = this.transformDateForDateField(moment());
                } else {
                    this.dateFields.registration_end = null;
                    this.dateFields.registration_start = null;
                }
            }
        }, true);

        this.scope.$watch(() => {
            return this.model.settings.registration_fields;
        }, () => {
            _.each(this.copyMainGuestFieldModels, (value, key) => {
                if (value.state && this.model.settings[value.enable_setting]) {
                    this.updateFieldDefinition(value.field_setting, _.cloneDeep(this.model.settings.registration_fields));
                } else if (!this.model.settings[value.enable_setting]) {
                    this.updateFieldDefinition(value.field_setting, []);
                }

            });
        }, true);

        this.scope.$watch(() => {
            return this.currentReloginStates;
        }, () => {
            const currentCount = ++this.reloginStatesUpdateCount;

            this.model.settings.enable_login_states = null;
            this.injector.get('$timeout')(() => {
                if (currentCount >= this.reloginStatesUpdateCount) {
                    this.model.settings.enable_login_states = _.cloneDeep(this.currentReloginStates);
                    this._triggerModelUpdate();
                }
            }, 0);
        }, true);

        this.scope.$watch(() => {
            return this.internalPaxPlannedMax;
        }, () => {
            if (this.modelPrepared) {
                console.log('pax change');
                this.model.settings.pax_planned_max = _.clone(this.internalPaxPlannedMax) + 1;
                this._triggerModelUpdate();
            }
        });
    }

    _initSpecialWatchers() {
        _.each(this.copyMainGuestFieldModels, (settings, key) => {
            this.scope.$watch(() => {
                return this.model.settings[settings.enable_setting];
            }, () => {
                if (this.modelPrepared) {
                    this.handleSubPersonGroupChange(key);
                }
            });
            this.scope.$watch(() => {
                return settings.state;
            }, () => {
                if (this.modelPrepared) {
                    this.handleCopyMainGuestFieldsChange(key);
                }
            });
        });
    }

    _fillModelFromGuestlist() {
        this.model = {
            uid: this.getGuestlistValue('uid'),
            settings: {
                registration_start: this.getGuestlistValue('settings.registration_start'),
                registration_end: this.getGuestlistValue('settings.registration_end'),
                enable_open_registration: this.getGuestlistValue('settings.enable_open_registration'),
                enable_code_registration: this.getGuestlistValue('settings.enable_code_registration'),
                enable_logged_in_registration: this.getGuestlistValue('settings.enable_logged_in_registration'),
                enable_guests: this.getGuestlistValue('settings.enable_guests'),
                guest_count_maximum: this.getGuestlistValue('settings.guest_count_maximum'),

                enable_representative: this.getGuestlistValue('settings.enable_representative'),
                representative_default_state: this.getGuestlistValue('settings.representative_default_state'),

                enable_recommendations: this.getGuestlistValue('settings.enable_recommendations'),
                recommendation_default_state: this.getGuestlistValue('settings.recommendation_default_state'),
                recommendation_count_maximum: this.getGuestlistValue('settings.recommendation_count_maximum'),

                open_reg_password: this.getGuestlistValue('settings.open_reg_password'),

                registration_fields: this.getGuestlistValue('settings.registration_fields'),
                registration_guest_fields: this.getGuestlistValue('settings.registration_guest_fields'),
                recommendations_fields: this.getGuestlistValue('settings.recommendations_fields'),
                representative_fields: this.getGuestlistValue('settings.representative_fields'),

                registration_status_flow: this.getGuestlistValue('settings.registration_status_flow'),
                enable_login_states: this.getGuestlistValue('settings.enable_login_states'),
                identify_contact_by_email: this.getGuestlistValue('settings.identify_contact_by_email'),
                overwrite_data_of_email_identified_contact: this.getGuestlistValue('settings.overwrite_data_of_email_identified_contact'),
                update_contact_data_on_logged_in: this.getGuestlistValue('settings.update_contact_data_on_logged_in'),
                pax_planned_max: this.getGuestlistValue('settings.pax_planned_max')
            }
        };
        this.internalPaxPlannedMax = this.getGuestlistValue('settings.pax_planned_max') - 1;
        if (this.internalPaxPlannedMax < 0) {
            this.internalPaxPlannedMax = 0;
        }
        this.currentReloginStates = this.getGuestlistValue('settings.enable_login_states');
        this.statusFlow = this.getGuestlistValue('settings.registration_status_flow');

        this.internalDefinitions = {
            registration_fields: this.getGuestlistValue('settings.registration_fields'),
            registration_guest_fields: this.getGuestlistValue('settings.registration_guest_fields'),
            recommendations_fields: this.getGuestlistValue('settings.recommendations_fields'),
            representative_fields: this.getGuestlistValue('settings.representative_fields'),
        };

        _.each(this.copyMainGuestFieldModels, (value, key) => {
            value.state = _.isEqual(this.model.settings.registration_fields, this.model.settings[value.field_setting]);
        });

        this.openRegPasswordEnabled = !!this.model.settings.open_reg_password;
        if (this.getGuestlistValue('settings.registration_start') || this.getGuestlistValue('settings.registration_end')) {
            this.registrationTimeRangeEnabled = true;
            this.dateFields.registration_start = this.transformDateForDateField(this.getGuestlistValue('settings.registration_start'));
            this.dateFields.registration_end = this.transformDateForDateField(this.getGuestlistValue('settings.registration_end'));
        } else {
            this.registrationTimeRangeEnabled = false;
            this.dateFields.registration_start = null;
            this.dateFields.registration_end = null;
        }

        this.doNotAutoConfirmOpenRegistration = !!this.getGuestlistValue();

        _.each(this.registrationTypes, (typeInfo) => {
            let typeIsValid = true;
            _.each(typeInfo.settings, (value, setting) => {
                if (!_.has(this.guestlist, `settings.${setting}`) || _.get(this.guestlist, `settings.${setting}`) !== value) {
                    typeIsValid = false;
                }
            });

            if (typeIsValid) {
                this.currentRegistrationType = typeInfo.key;
            }
        });

        this.fields = this.guestlist.fields;

        this.injector.get('$timeout')(() => {
            this.modelPrepared = true;
        }, 0);
    }

    _initFormConfig() {
        const formConfig = {
            ...this.state.formConfig,
            registrationTypes: [],
            rsvpStates: [],
            statusMappings: []
        };

        _.each(this.registrationTypes, (typeConfig) => {
            formConfig.registrationTypes.push({
                key: typeConfig.key,
                label: this.translate.instant(`guestlists.editor.pages.form.registrationTypes.${typeConfig.key}.label`),
                help_text: this.translate.instant(`guestlists.editor.pages.form.registrationTypes.${typeConfig.key}.help_text`)
            })
        });

        this._updateState({
            ...this.state,
            formConfig
        });

        this.depositService.getRemoteDeposit('rsvps', 'states', []).then((depositRsvpStates) => {
            const formConfig = {
                rsvpStates: [],
                statusMappings: []
            };

            _.each(depositRsvpStates, (v, k) => {
                formConfig.rsvpStates.push({
                    value: k,
                    label: v
                })
            });

            _.each(this.statusMappingPresets, (presetConfig) => {
                const currentMapping = {
                        default: []
                    },
                    currentLoginStates = _.map(depositRsvpStates, (sL, sS) => {
                        return sS;
                    });

                _.each(depositRsvpStates, (label, status) => {
                    let currentMappingStates = [];

                    switch (presetConfig.key) {
                        case 'allow_cancellation':
                            currentMappingStates.push('cancelled');
                            break;
                        case 'allow_all_changes':
                            currentMappingStates = _.map(depositRsvpStates, (sL, sS) => {
                                return sS;
                            });
                            break;
                    }

                    if (status !== 'waitlisted') {
                        if (currentMappingStates.indexOf('confirmed') === -1) {
                            currentMappingStates.push('confirmed');
                        }
                    }

                    if (currentMappingStates.indexOf(status) === -1) {
                        currentMappingStates.push(status);
                    }

                    currentMapping[status] = currentMappingStates;
                });

                formConfig.statusMappings.push({
                    key: presetConfig.key,
                    label: this.translate.instant(`guestlists.editor.pages.form.statusMappingPresets.${presetConfig.key}`),
                    mapping: (presetConfig.key !== 'individual') ? currentMapping : null,
                    loginStates: (presetConfig.key !== 'individual') ? currentLoginStates : null
                });

            });

            this._updateState({
                ...this.state,
                formConfig: {
                    ...this.state.formConfig,
                    ...formConfig
                }
            });

            this.injector.get('$timeout')(() => {
                // this._checkCurrentStatusMappingPreset();
            }, 0);
        })
    }

    _checkCurrentStatusMappingPreset() {
        if (this.state.formConfig.statusMappings.length > 0 && this.modelPrepared) {
            let mappingSet = false;

            _.each(this.state.formConfig.statusMappings, (mapping) => {
                if (_.isEqual(mapping.mapping, _.get(this.model, 'settings.registration_status_flow'))) {
                    mappingSet = true
                    this.currentStatusMappingPreset = mapping.key;
                }
            });

            if (!mappingSet) {
                this.currentStatusMappingPreset = 'individual';
            }
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-landingpage-editor/pages/form/controller.js